export const decodeJwtPayload = (jwt: string): Record<string, unknown> => {
  const parts = jwt.split('.');
  if (parts.length !== 3 || !parts[1]) {
    throw new Error(`Invalid JWT: ${jwt}`);
  }
  const base64 = parts[1].replaceAll('-', '+').replaceAll('_', '/');
  const json = decodeURIComponent(
    atob(base64)
      .split('')
      .map((character) => '%' + character.codePointAt(0)!.toString(16).padStart(2, '0'))
      .join(''),
  );
  return JSON.parse(json) as Record<string, unknown>;
};
